import React from "react";
import styles from './suporte.module.css';
import logo from '../../../logo.jpg';

function Suporte() {
    return (
        <div className={styles.container}>
            {/* Header Minimalista */}
            <header className={styles.header}>
                <img src={logo} alt="Logo" className={styles.logo} />
            </header>

            <main className={styles.content}>
                <section className={styles.hero}>
                    <span className={styles.tagline}>Suporte Personalizado</span>
                    <h1 className={styles.title}>Estamos aqui para ouvir você.</h1>
                    <p className={styles.description}>
                        Na nossa loja, acreditamos no atendimento humanizado. 
                        Não utilizamos sistemas automáticos ou FAQs extensas. 
                        Toda e qualquer dúvida é tratada diretamente com a nossa equipe.
                    </p>
                </section>

                <section className={styles.contactGrid}>
                    {/* Opção WhatsApp */}
                    <a href="https://wa.me/seunumeroaqui" className={styles.contactCard}>
                        <div className={styles.cardHeader}>
                            <span className={styles.icon}>💬</span>
                            <h3>Conversa Direta</h3>
                        </div>
                        <p>Dúvidas rápidas e suporte imediato via WhatsApp.</p>
                        <span className={styles.actionLink}>Iniciar conversa →</span>
                    </a>

                    {/* Opção E-mail */}
                    <a href="mailto:suporte@sualoja.com" className={styles.contactCardHighlight}>
                        <div className={styles.cardHeader}>
                            <span className={styles.icon}>✉️</span>
                            <h3>E-mail Oficial</h3>
                        </div>
                        <p>Para questões detalhadas sobre pedidos ou parcerias.</p>
                        <span className={styles.actionLink}>Enviar e-mail →</span>
                    </a>
                </section>

                <section className={styles.infoSection}>
                    <div className={styles.infoBox}>
                        <h4>Horário de Atendimento</h4>
                        <p>Segunda a Sexta: 09h às 18h</p>
                        <p>Sábado: 09h às 13h</p>
                    </div>
                    <div className={styles.infoBox}>
                        <h4>Prazo de Resposta</h4>
                        <p>Nossa equipe responde em até 24 horas úteis.</p>
                    </div>
                </section>
            </main>

            <footer className={styles.footer}>
                <p>Sua satisfação é nossa prioridade absoluta.</p>
            </footer>
        </div>
    );
};

export default Suporte;